import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import CommitCtaModal from './CommitCtaModal';
import './Navigation.css';

function Navigation() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const isLandingPage = location.pathname === '/group' || location.pathname === '/mobile';
  const [commitModalOpen, setCommitModalOpen] = useState(false);

  useEffect(() => {
    if (!isHomePage && !isLandingPage) setCommitModalOpen(false);
  }, [isHomePage, isLandingPage]);
  
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  
  return (
    <>
    <nav className="navigation">
      <div className="nav-container">
        {isHomePage ? (
          <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="nav-logo nav-logo-button">
            <span className="logo-text">BODYWORKS</span>
          </button>
        ) : (
          <Link to="/" className="nav-logo">
            <span className="logo-text">BODYWORKS</span>
          </Link>
        )}
        
        <div className="nav-links">
          {isHomePage && (
            <>
              <button type="button" onClick={() => scrollToSection('growth-section')} className="nav-link nav-link-button">Services</button>
              <button type="button" onClick={() => scrollToSection('contact')} className="nav-link nav-link-button">Contact</button>
              <button type="button" onClick={() => scrollToSection('trainers')} className="nav-link nav-link-button">Trainers</button>
            </>
          )}
          {!isHomePage && !isLandingPage && (
            <Link to="/" className="nav-link">Home</Link>
          )}
          {isLandingPage && (
            <Link to="/" className="nav-visit-home-btn">
              Visit Homepage
            </Link>
          )}
          {(isHomePage || isLandingPage) && (
            <button
              type="button"
              onClick={() => setCommitModalOpen(true)}
              className="nav-commit-btn"
            >
              Commit Now
            </button>
          )}
        </div>
      </div>
    </nav>
    {(isHomePage || isLandingPage) && (
      <CommitCtaModal isOpen={commitModalOpen} onClose={() => setCommitModalOpen(false)} />
    )}
    </>
  );
}

export default Navigation;
